import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Autocomplete } from 'components/FormFields';

const ReservationsRulesSelect = ({
  id,
  label,
  variant,
  field: { name, value },
  type,
  form: { errors, touched, setFieldValue },
  disabled,
  required,
}) => {
  const [defaultValue, setDefaultValue] = useState(null);
  const { rules, fetchingRules } = useSelector((state) => state.reservations);

  useEffect(() => {
    if (value) {
      const defaultVal = rules.find((el) => el.id === value);
      if (defaultVal) {
        setDefaultValue(defaultVal);
      }
    } else {
      setDefaultValue(null);
    }
  }, [value, rules]) // eslint-disable-line

  return (
    <Autocomplete
      id={id}
      label={label}
      margin="normal"
      fullwidth="true"
      variant={variant}
      disabled={disabled}
      value={defaultValue}
      loading={fetchingRules}
      required={required}
      options={rules || []}
      getOptionLabel={(option) => option.name || ''}
      onChange={(ev, val) => setFieldValue(name, val?.id || '')}
      error={errors && errors[name] && touched && touched[name]}
      getOptionSelected={(option, value) => option.id === value.id}
      helperText={errors && errors[name] && touched && touched[name] && errors[name]}
    />
  );
};

ReservationsRulesSelect.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  customParams: PropTypes.object,
  omitFields: PropTypes.array,
  omitFieldKey: PropTypes.string,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

ReservationsRulesSelect.defaultProps = {
  required: false,
  disabled: false,
  form: {
    errors: {},
    touched: {},
  },
  omitFields: [],
  customParams: {},
  label: 'Select...',
  variant: 'standard',
};

export default ReservationsRulesSelect;
